<template>
  <div class="menucontrol-scroll fixed-top">
    <Banner />
    <CourseCard />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import CourseCard from "./components/CourseCard.vue";
export default {
  components: {
    Banner,
    CourseCard,
  },
};
</script>
